import React from 'react'
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';

const styles = theme => ({
    formControl: {
        marginTop: theme.spacing.unit,
        minWidth: 220,
    },
    selectEmpty: {
        //marginTop: theme.spacing.unit * 2,
    },
});

function Technics(props) {

    const { classes, label, list } = props;

    return (
        <React.Fragment>
            <FormControl fullWidth className={classes.formControl} disabled={props.disable}>
                <InputLabel htmlFor="model">{label}</InputLabel>
                <Select
                    value={props.value}
                    onChange={props.onChange}
                    input={<Input id="model" />}>

                    {(list.length === 0) ? <MenuItem value="" disabled>Немає результатів</MenuItem> : <MenuItem value="" disabled></MenuItem>}
                    {list.map((item) => {
                        return <MenuItem key={item.id} value={item.id}>{item.name} </MenuItem>
                    })}
                </Select>
            </FormControl>
        </React.Fragment>
    )


}

export default withStyles(styles)(Technics);


// WEBPACK FOOTER //
// ./src/components/Technics/Technics.js